import { User } from '../../models/User'
import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Modal } from '../../components/Modal/Modal'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useDeleteUserByIdMutation } from '../../store/user/user'

interface DeleteUserModalProps {
  user?: User
  show: boolean
  onHide: () => void
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ user, show, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const [deleteUser, deleteUserResult] = useDeleteUserByIdMutation()
  const handleDeleteUser = async () => {
    if (user) {
      deleteUser({ accountId: accountId, userId: user.id })
    }
  }

  useEffect(() => {
    if (deleteUserResult.isSuccess) {
      onHide()
    }
  }, [deleteUserResult])

  if (!user) {
    return null
  }

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Delete User</h4>
        </Col>
      </Row>
      <Row className='pb-4'>
        <Col className='p-0'>
          <p className='paragraph-medium'>
            Are you sure you want to delete user <b>{user.name || user.email || user.id}</b>?
          </p>
          <p className='paragraph-medium'>
            This action is permanent. All of this user's meetings, notes, and related data will be permanently deleted and cannot be recovered.
          </p>
        </Col>
      </Row>
      <Row></Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={handleDeleteUser}
      footerPrimaryActionLoading={deleteUserResult.isLoading}
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
    />
  )
}
